var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.step === 1
        ? _c("GrmCamstudyOptionModal", {
            attrs: {
              title: _vm.$t("camstudy.participant.selectExitType"),
              list: _vm.exitOptions,
              button: _vm.optionModalButtons,
              value: "kick",
            },
            on: {
              onCloseOption: _vm.close,
              onNextAct: _vm.selectKickOrBanUser,
            },
          })
        : _vm._e(),
      _vm.step === 2
        ? _c(
            "CamstudyPromptModal",
            {
              attrs: {
                warning: true,
                button: _vm.promptModalButtons,
                title: _vm.$t("camstudy.participant.banReason"),
              },
              on: { onClosePrompt: _vm.close, onNextAct: _vm.banUser },
            },
            [
              _c("div", [
                _c(
                  "select",
                  {
                    staticClass: "participant-modal-select",
                    on: {
                      input: (e) =>
                        (_vm.selectedBanReason.value = e.target.value),
                    },
                  },
                  _vm._l(_vm.banReasonOption, function (option, i) {
                    return _c(
                      "option",
                      {
                        key: i,
                        domProps: {
                          value: option.value,
                          selected:
                            option.value === _vm.selectedBanReason.value,
                        },
                      },
                      [_vm._v(_vm._s(option.title))]
                    )
                  }),
                  0
                ),
                _c("textarea", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedBanReason.value === "etc",
                      expression: "selectedBanReason.value === 'etc'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.description,
                      expression: "description",
                    },
                  ],
                  staticClass: "etc-textarea",
                  attrs: {
                    maxlength: "30",
                    placeholder: _vm.$t("camstudy.participant.etcPlaceholder"),
                  },
                  domProps: { value: _vm.description },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.description = $event.target.value
                    },
                  },
                }),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }